import { createReducer, on } from '@ngrx/store';
import { IReviewerScreeningStats } from '@core/state/entities/reviewer-screening-stats/reviewer-screening-stats.entity';
import { defaultEntityState } from '@core/state/entities/entity';
import { stageActions } from '@core/actions/stage.actions';
import { mergeEntityState } from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';
import { projectDetailActions } from '@core/actions/project-detail.actions';

export const reviewerScreeningStatsEntityReducer = createReducer(
  defaultEntityState<IReviewerScreeningStats>(),
  on(
    stageActions.receivedStageReviewerStats,
    projectDetailActions.receivedProjectReviewerStats,
    (state, props) =>
      mergeEntityState(entityKey.reviewerScreeningStats, state, props)
  )
);
